// @ts-nocheck
import _, { debounce, union } from "lodash";
import {
  getComponentUserSettings,
  getGridData,
  getGridMetadata,
  getTableSelection,
} from "models/dynamicGrid/selector";
import { updateTableColumnConfigAg } from "models/tableColumns/sagaActions";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { getDispatch, getState } from "reducers";
import { GRID_EVENTS } from "../molecules/ReactGrid/agGrid/constants";
import { Events } from "../molecules/ReactGrid/agGrid/utils/events";
import {
  getTableColumnQueue,
  getTableColumnsInfo,
} from "../models/tableColumns/selector";
import {
  addColumnOperations,
  updateTableColumns,
} from "models/tableColumns/reducer";
import {
  refreshGridData,
  updateRowData,
  updateSelectedRows,
} from "models/dynamicGrid/sagaActions";
import { useSelector } from "react-redux";
import { updateMetadata } from "models/dynamicGrid/reducer";
import { REQUESTS } from "utils/services/thetaretail/requests";
import {
  createServer,
  createServerSideDatasource,
} from "molecules/ReactGrid/agGrid/queries";
import { getGridFilterName } from "models/dynamicGrid/query";
import extractRangeInfo from "helper/getObjectWithMaxArrayLength";

// Persistent debounced function for column resize API calls
// This ensures the debounce actually works across multiple resize events
const debouncedColumnResizeDispatch = _.debounce(
  (dispatch, tableId, bulkUpdateColumns) => {
    dispatch(
      updateTableColumnConfigAg({
        payload: {
          tableId,
          isBulkUpdate: true,
          bulkUpdateColumns,
        },
      })
    );
  },
  300
);

export const onProcessColumnQueue = ({ params, tableId, isReset }) => {
  // return new Promise((resolve) => {
  const { api } = params;
  const dispatch = getDispatch();
  const columnOperations = getTableColumnQueue(getState(), tableId);
  const updatesQueue = columnOperations.filter((u) => {
    return u.source !== "gridOptionsChanged" && u.source !== "flex";
  });
  // let columns = getTableColumns(getState(), tableId)?.map(c => ({ ...c, index: api.getColumnDefs()?.findIndex(col => col?.colId === c?.AppColumnName) }))?.sort((a, b) => a.index - b.index)?.map(c => _.omit(c, ['index']));

  if (!updatesQueue.length) {
    dispatch(
      addColumnOperations({
        tableId,
        columnOperations: [],
        isReplace: true,
      })
    );
    return;
  }
  let columns = api
    .getColumnDefs()
    .filter((c) => c?.metaData?.AppColumnID)
    .map((c) => c.metaData);

  for (let update of updatesQueue) {
    for (let uCol of update.columns) {
      columns = columns.map((col, index) => {
        if (col.AppColumnName === uCol.colId) {
          col.IsColumnEnabled =
            update.type === "columnVisible"
              ? uCol.visible
              : col.IsColumnEnabled;
          col.PinPreference = uCol.pinned;
          col.IsFixedColumn = Boolean(uCol.pinned);
          col.ColumnWidth = uCol.actualWidth;
        }

        return { ...col, DefaultSortOrder: index };
      });
    }
  }
  dispatch(
    updateTableColumnConfigAg({
      payload: {
        tableId: tableId,
        isBulkUpdate: true,
        bulkUpdateColumns: columns,
        updatesQueue,
        isInternal: true,
        isReset,
      },
    })
  );
};

const onColumnMoved = (params) => {
  setTimeout(() => {
    const { toIndex, api, finished } = params;
    const dispatch = getDispatch();
    if (!finished) return;
    // if (params.source === "gridOptionsChanged" || eventInProgress === "pinned") {
    //   // eventInProgress = "";
    //   return;
    // }
    // if (!toIndex) {
    //   return;
    // }

    const updatedCols = _.map(
      api.getColumnDefs().filter((c) => c?.metaData?.AppColumnID),
      (d, index) => ({ ...d.metaData, DefaultSortOrder: index })
    );

    const bulkUpdateColumns = updatedCols.map(({ children, ...rest }) => rest);

    if (!updatedCols.length) return;
    const tableId = updatedCols[0].tableId;
    dispatch(
      updateTableColumns({
        tableId,
        tableColumns: updatedCols,
      })
    );
    dispatch(
      updateTableColumnConfigAg({
        payload: {
          tableId,
          isBulkUpdate: true,
          bulkUpdateColumns,
          isInternal: true,
        },
      })
    );
  }, 0);
};

const onColumnPinned = (params) => {
  setTimeout(() => {
    const { columns, pinned, column } = params;
    const tableId = columns[0].colDef.metaData.AppTableID;
    const tableColumns = getTableColumnsInfo(getState(), tableId);

    if (params.source === "gridOptionsChanged" || params.source === "flex") {
      return;
    }
    // const eventInProgress = "pinned";
    const dispatch = getDispatch();
    if (columns?.length > 1 && pinned === null) {
      return;
    }

    if (
      !columns?.find((res) =>
        tableColumns?.find((ut) => res.colDef.field === ut.AppColumnName)
      )
    ) {
      return;
    }

    const updateColumns = _.map(tableColumns, (c) =>
      c.AppColumnName === column?.colDef?.field
        ? {
            ...c,
            PinPreference: pinned,
            IsFixedColumn: Boolean(pinned),
          }
        : c
    );

    dispatch(
      updateTableColumns({
        tableId,
        tableColumns: updateColumns,
      })
    );

    const bulkUpdateColumns = updateColumns.map(
      ({ children, ...rest }) => rest
    );

    dispatch(
      updateTableColumnConfigAg({
        payload: {
          tableId,
          isBulkUpdate: true,
          bulkUpdateColumns,
        },
      })
    );
  }, 0);
};

const onColumnVisible = (options) => {
  setTimeout(() => {
    let { visible, column, columns } = options;
    const dispatch = getDispatch();
    const updatedColumns = _.filter(columns, (f) => f?.colDef?.field);
    const tableId = updatedColumns[0]?.colDef?.metaData?.tableId;
    const updatedTableColumns = getTableColumnsInfo(getState(), tableId);

    if (
      !updatedTableColumns.length ||
      options.type !== "columnVisible" ||
      options.source === "gridOptionsChanged"
    ) {
      return;
    }

    if (
      !columns.find((res) =>
        updatedTableColumns.find((ut) => res.colDef.field === ut.AppColumnName)
      )
    ) {
      return;
    }

    const tableColumns = column
      ? _.map(updatedTableColumns, (c) =>
          c.AppColumnName === column?.colDef?.field
            ? {
                ...c,
                IsColumnEnabled: visible,
              }
            : c
        )
      : _.map(updatedTableColumns, (c) => ({
          ...c,
          IsColumnEnabled: visible,
        }));

    dispatch(
      updateTableColumns({
        tableId,
        tableColumns,
      })
    );

    const bulkUpdateColumns = tableColumns.map(({ children, ...rest }) => rest);

    dispatch(
      updateTableColumnConfigAg({
        payload: {
          tableId,
          isBulkUpdate: true,
          bulkUpdateColumns,
        },
      })
    );
  }, 0);
};

const onColumnResized = (options) => {
  const dispatch = getDispatch();
  const { column, finished, columns, source, api } = options;
  if (
    !finished ||
    !columns?.length ||
    source === "flex" ||
    source === "toolPanelUi"
  ) {
    return;
  }

  if (source === "autosizeColumns" && !column) {
    return;
  }

  const updatedColumns = _.filter(columns, (f) => f?.colDef?.field);
  const tableId = updatedColumns[0]?.colDef?.metaData?.tableId;
  const updatedTableColumns = getTableColumnsInfo(getState(), tableId);

  if (
    !columns?.find((res) =>
      updatedTableColumns?.find((ut) => res.colDef.field === ut.AppColumnName)
    )
  ) {
    return;
  }

  const tableColumns = column
    ? _.map(updatedTableColumns, (c) =>
        c.AppColumnName === column?.colDef?.field ||
        c.AppColumn === column?.colDef?.headerName
          ? { ...c, ColumnWidth: column.actualWidth }
          : c
      )
    : _.map(updatedTableColumns, (c) =>
        _.find(updatedColumns, (res) => c.AppColumnName === res.colDef.field)
          ? {
              ...c,
              ColumnWidth: _.find(
                updatedColumns,
                (res) => c.AppColumnName === res.colDef.field
              )?.actualWidth,
            }
          : c
      );

  dispatch(updateTableColumns({ tableId, tableColumns }));

  const bulkUpdateColumns = tableColumns.map(({ children, ...rest }) => rest);

  // Use the persistent debounced function to batch rapid resize events
  debouncedColumnResizeDispatch(dispatch, tableId, bulkUpdateColumns);
};

export function useAgGrid(params) {
  const {
    tableId,
    gridRef,
    childTableId,
    childGridRef,
    selectRowKey,
    gridMeta,
    onDomRef,
    isStorageEnabled,
    isViewImplementationOverride,
    isViewRLA,
  } = params;
  const timeoutIdRef = useRef(null);
  const dispatch = getDispatch();
  const metaData = getGridMetadata(getState(), tableId);
  const [loading, setLoading] = React.useState(true);
  const [refreshTimestamp, updateTimestamp] = useState(null);
  const [isGroupingEnabled, handleUpdateGrouping] = useState(false);
  const selectedInfo: any = useSelector((state) =>
    getTableSelection(state, tableId)
  );

  useEffect(() => {
    if (gridRef && gridMeta?.refreshTimestamp !== refreshTimestamp) {
      // Use purge: false to preserve aggregated rows when refreshing
      // This prevents aggregated data from disappearing when groups are expanded
      // Only purge when explicitly doing a hard refresh (isSoftRefresh is false or undefined)
      const shouldPurge = gridMeta?.isSoftRefresh !== true;
      gridRef?.current?.api?.refreshServerSide({ 
        route: [], 
        purge: shouldPurge 
      });
    }
    updateTimestamp(Date.now());
  }, [gridMeta?.refreshTimestamp, gridRef, gridMeta?.isSoftRefresh]);

  useEffect(() => {
    if (!gridRef?.current) return;
    const interval = setInterval(() => {
      gridRef.current.api.forEachNode((node) => {
        const updatedRow = { ...node.data };
        let hasChange = false;

        Object.entries(updatedRow).forEach(([key, value]) => {
          if (
            value &&
            typeof value === "object" &&
            value.isUpdated &&
            "value" in value
          ) {
            updatedRow[key] = value.value;
            hasChange = true;
          }
        });

        const detailApi = node?.detailNode?.detailGridInfo?.api;
        if (detailApi) {
          detailApi.forEachNode((detailNode) => {
            const updatedChildRow = { ...detailNode.data };
            let hasChildChange = false;

            Object.entries(updatedChildRow).forEach(
              ([childkey, childValue]) => {
                if (
                  childValue &&
                  typeof childValue === "object" &&
                  childValue.isUpdated &&
                  "value" in childValue
                ) {
                  updatedChildRow[childkey] = childValue.value;
                  hasChildChange = true;
                }
              }
            );
            if (hasChildChange) {
              detailNode.setData(updatedChildRow);
            }
          });
        }

        if (hasChange) {
          node.setData(updatedRow);
        }
      });
    }, 5000); // Check every 500ms

    return () => clearInterval(interval);
  }, [gridRef]);


  useEffect(() => {
    if (gridRef?.current) {
      // Helper function to process UPDATE_GRID event
      const processUpdateGridEvent = (data, tableId) => {
        // Use selectRowKey from event data if available, otherwise get from metadata
        const rowIdentifier = data.selectedRowKeyName || getGridMetadata(
          getState(),
          tableId
        )?.selectRowKey;

        let foundAnyRow = false;
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.forEachNode((node) => {
            const updatedRowData = _.find(
              data.updatedRows,
              (d) =>
                String(d?.[rowIdentifier]) ===
                String(node.data?.[rowIdentifier])
            );

            if (updatedRowData && node.data) {
              foundAnyRow = true;
              
              // Check if this is an error update (from validation errors)
              const rowId = node.data[rowIdentifier];
              const rowIdentifierKey = data.updatedRow?.rowIdentifier || Object.keys(updatedRowData).find(k => (k.includes('Qty') || k.includes('qty')) && k !== rowIdentifier);
              const cellValue = rowIdentifierKey ? updatedRowData[rowIdentifierKey] : null;
              
              // If error detected, revert to original value
              if (data.hasErrors || (cellValue && typeof cellValue === 'object' && cellValue.hasError)) {
                const errorRowIdentifier = data.updatedRow?.rowIdentifier || rowIdentifierKey;
                const originalValue = originalValuesRef.current[rowId]?.[errorRowIdentifier];
                
                // Revert the cell value to original if available
                if (originalValue !== undefined && errorRowIdentifier) {
                  updatedRowData[errorRowIdentifier] = {
                    value: originalValue,
                    hasError: true,
                    errorMessage: cellValue?.errorMessage || "Failed to update, Please try again later.",
                  };
                  
                  // Clear original value after reversion
                  if (originalValuesRef.current[rowId]) {
                    delete originalValuesRef.current[rowId][errorRowIdentifier];
                    if (Object.keys(originalValuesRef.current[rowId]).length === 0) {
                      delete originalValuesRef.current[rowId];
                    }
                  }
                } else if (errorRowIdentifier && cellValue?.hasError) {
                  // If no original value stored, try to get it from the node's current data
                  const currentCellValue = node.data[errorRowIdentifier];
                  const currentOriginalValue = typeof currentCellValue === 'object' && currentCellValue?.value !== undefined
                    ? currentCellValue.value
                    : currentCellValue;
                  
                  // Only revert if we have a valid original value
                  if (currentOriginalValue !== undefined && currentOriginalValue !== cellValue.value) {
                    updatedRowData[errorRowIdentifier] = {
                      value: currentOriginalValue,
                      hasError: true,
                      errorMessage: cellValue.errorMessage,
                    };
                  }
                }
              }
              
              // Update node directly since transaction won't work without getRowId
              node.updateData({ ...node.data, ...updatedRowData });
              // refreshCells ensures all calculated columns/secondary data updates visually
              gridRef.current.api.refreshCells({
                rowNodes: [node],
                force: true,
              });
            }
          });
        }
        
        // If we have updated rows but didn't find any in the current view,
        // trigger a soft refresh to ensure state is synced (for server-side grids)
        // This handles cases where rows might be on a different page or filtered out
        if (!foundAnyRow && data.updatedRows?.length > 0 && gridRef.current?.api?.refreshServerSide) {
          // Use a small delay to avoid race conditions
          setTimeout(() => {
            gridRef.current?.api?.refreshServerSide({ 
              route: [], 
              purge: false 
            });
          }, 100);
        }
      };

      // --- 1. PURGE_GRID_ROUTE: Refresh without flickering ---
      Events.subscribe(GRID_EVENTS.PURGE_GRID_ROUTE, (data) => {
        if (data.tableId != tableId) return;
        gridRef.current.api.refreshServerSide({
          route: data.route,
          purge: false, // CRITICAL: false prevents "Loading..." rows
          suppressFlash: true,
        });
      });

      // --- 2. UPDATE_GRID: Update multiple rows silently ---
      Events.subscribe(GRID_EVENTS.UPDATE_GRID, (data) => {
        const eventTableId = Number(data.tableId);
        // Robustness: Clear pending API call on successful grid update (bulk/multi-row)
        if ((eventTableId === 1 || eventTableId === 2 || eventTableId === 3 || eventTableId === 115) && pendingApiCallRef.current) {
          pendingApiCallRef.current = false;
          publishDirtyState();
        }

        if (Number(data.tableId) === Number(tableId)) {
          // CRITICAL: If grid is not ready after navigation, wait for it to be ready
          if (!gridRef.current || !gridRef.current.api) {
            // Wait for grid to be ready (max 5 seconds)
            let attempts = 0;
            const maxAttempts = 50; // 50 * 100ms = 5 seconds
            const checkGridReady = setInterval(() => {
              attempts++;
              if (gridRef.current && gridRef.current.api) {
                clearInterval(checkGridReady);
                // Process the update now that grid is ready
                processUpdateGridEvent(data, tableId);
              } else if (attempts >= maxAttempts) {
                clearInterval(checkGridReady);
              }
            }, 100);
            return;
          }
          
          // Process update immediately if grid is ready
          processUpdateGridEvent(data, tableId);
        } else if (Number(data.tableId) === Number(childTableId)) {
          // Child/Detail table logic
          gridRef.current.api.forEachNode((r) => {
            if (r.data?.[selectRowKey] === data.row?.[selectRowKey]) {
              const detailApi = r.detailGridInfo?.api;
              if (detailApi) {
                const childRowKey = getGridMetadata(
                  getState(),
                  data.tableId
                )?.selectRowKey;
                detailApi.forEachNode((detailNode) => {
                  const updatedChild = _.find(
                    data.updatedRows,
                    (d) =>
                      String(d?.[childRowKey]) ===
                      String(detailNode.data?.[childRowKey])
                  );
                  if (updatedChild) {
                    detailNode.updateData({
                      ...detailNode.data,
                      ...updatedChild,
                    });
                    detailApi.refreshCells({
                      rowNodes: [detailNode],
                      force: true,
                    });
                  }
                });
              }
            }
          });
        }
      });

      // --- 3. CLEAR_SELECTION ---
      Events.subscribe(GRID_EVENTS.CLEAR_SELECTION, (data) => {
        if (Number(data.tableId) === Number(tableId)) {
          gridRef?.current?.api?.deselectAll();
        } else if (Number(data.tableId) === Number(childTableId)) {
          childGridRef?.current?.api.deselectAll();
        }
      });

      // --- 4. UPDATE_GRID_CELL: Single cell + Related data update ---
      Events.subscribe(GRID_EVENTS.UPDATE_GRID_CELL, (data) => {
        const eventTableId = Number(data.tableId);
        // Clear pendingApiCall when we get response (success or error) for order table updates
        if ((eventTableId === 1 || eventTableId === 2 || eventTableId === 3 || eventTableId === 115) && pendingApiCallRef.current) {
          pendingApiCallRef.current = false;
          publishDirtyState();
        }

        const updatedRowPayload = data?.updatedRow;
        const rowKey = updatedRowPayload.rowIdentifier;
        const findKey = data.selectedRowKeyName;
        const findValue = data.selectedRowKeyValue;

        const buildUpdatedRow = (existingData) => {
          // Get updateRow - it should contain Current_Available_Qty and other updated fields
          const updateRow = updatedRowPayload.updateRow || {};
          
          // Extract cell value - handle both object (with hasError/isUpdated) and primitive values
          const cellValueObj = updatedRowPayload.updatedValue;
          const isCellValueObject = cellValueObj && typeof cellValueObj === 'object' && !Array.isArray(cellValueObj);
          
          // For successful updates, ensure cell value is an object with isUpdated flag
          // For errors, preserve the error object
          let cellValue;
          if (isCellValueObject) {
            cellValue = cellValueObj;
          } else if (cellValueObj?.value !== undefined) {
            // If it has a value property, use the whole object
            cellValue = cellValueObj;
          } else {
            // For primitive values on success, wrap in object with isUpdated
            const hasError = updatedRowPayload.updatedValue?.hasError;
            const isUpdated = updatedRowPayload.updatedValue?.isUpdated;
            if (hasError || isUpdated) {
              cellValue = updatedRowPayload.updatedValue;
            } else {
              // Fallback: create object with value and isUpdated
              cellValue = {
                value: cellValueObj,
                isUpdated: true,
              };
            }
          }
          
          // Build new row data - spread updateRow but handle Current_Available_Qty carefully
          // IMPORTANT: Preserve existing cell value (which may have error state) before spreading updateRow
          const existingCellValue = existingData[rowKey];
          const newRowData = {
            ...existingData,
            ...updatedRowPayload.row,
          };
          
          // Only update Current_Available_Qty if updateRow has a valid (non-zero) value
          // The API might return 0 which would overwrite the existing value incorrectly
          if (updateRow.Current_Available_Qty !== undefined && updateRow.Current_Available_Qty !== null && updateRow.Current_Available_Qty !== 0) {
            newRowData.Current_Available_Qty = updateRow.Current_Available_Qty;
          }
          if (updateRow.CurrentAvailableQuantity !== undefined && updateRow.CurrentAvailableQuantity !== null && updateRow.CurrentAvailableQuantity !== 0) {
            newRowData.CurrentAvailableQuantity = updateRow.CurrentAvailableQuantity;
          }
          
          // Spread other fields from updateRow (excluding Current_Available_Qty which we handled above)
          // and excluding pivot column keys which we'll handle separately
          // CRITICAL: Exclude the rowKey from updateRow to prevent overwriting error state
          Object.keys(updateRow).forEach(key => {
            if (key !== 'Current_Available_Qty' && key !== 'CurrentAvailableQuantity' && !key.includes('|ItemOrderQty') && key !== rowKey) {
              newRowData[key] = updateRow[key];
            }
          });
          
          // Set cell value last to ensure it's not overwritten
          // For pivot mode, rowKey is like "179|ItemOrderQty"
          // CRITICAL: Always preserve error state - if cellValue has error, use it; otherwise keep existing error if present
          if (cellValue && typeof cellValue === 'object' && cellValue.hasError) {
            // Error state - revert to original value if available
            const rowId = existingData[findKey || getGridMetadata(getState(), eventTableId)?.selectRowKey];
            const originalValue = originalValuesRef.current[rowId]?.[rowKey];
            
            // Revert to original value if available, otherwise keep error value
            newRowData[rowKey] = {
              value: originalValue !== undefined ? originalValue : cellValue.value,
              hasError: true,
              errorMessage: cellValue.errorMessage,
            };
            
            // Clear original value after reversion
            if (originalValue !== undefined && originalValuesRef.current[rowId]) {
              delete originalValuesRef.current[rowId][rowKey];
              if (Object.keys(originalValuesRef.current[rowId]).length === 0) {
                delete originalValuesRef.current[rowId];
              }
            }
          } else if (existingCellValue && typeof existingCellValue === 'object' && existingCellValue.hasError) {
            // Preserve existing error state - merge with new value but keep error properties
            newRowData[rowKey] = { 
              ...existingCellValue, 
              ...(cellValue && typeof cellValue === 'object' ? cellValue : { value: cellValue }),
              // Keep error state if it exists
              hasError: existingCellValue.hasError,
              errorMessage: existingCellValue.errorMessage
            };
          } else {
            // Normal update - use cellValue (which may be object with isUpdated or primitive)
            newRowData[rowKey] = cellValue;
            
            // Clear original value on successful update
            const rowId = existingData[findKey || getGridMetadata(getState(), eventTableId)?.selectRowKey];
            if (originalValuesRef.current[rowId]) {
              delete originalValuesRef.current[rowId][rowKey];
              if (Object.keys(originalValuesRef.current[rowId]).length === 0) {
                delete originalValuesRef.current[rowId];
              }
            }
          }
          
          return newRowData;
        };

if (updatedRowPayload.isPivotMode) {
          // The transaction format for pivot mode can be complex; we stick to manual setData but use forEachNode
          // For tableId 115 (Order Pivot), match by grouping keys instead of pivot column
          const groupingKeys = Number(data.tableId) === 115 
            ? ['Item', 'ItemDescription', 'Genus', 'Size', 'CustomerName', 'Warehouse', 'Current_Available_Qty']
            : null;
          
          let matchedCount = 0;
          gridRef?.current?.api.forEachNode((r) => {
            let isMatch = false;
            
            if (Number(data.tableId) === 115 && groupingKeys) {
              // For Order Pivot: match by grouping keys (excluding pivot columns)
              const searchRow = data?.updatedRow?.row;
              const nodeData = r?.data;
              
              // Match by all grouping keys
              isMatch = groupingKeys.every(key => {
                const searchValue = searchRow?.[key];
                const nodeValue = nodeData?.[key];
                return searchValue === nodeValue || (searchValue == null && nodeValue == null);
              });
            } else {
              // For other pivot tables: use original matching logic
              isMatch = data?.updatedRow?.row?.[rowKey] === r?.data?.[rowKey] &&
                _.isEqualWith(
                  _.omit(data?.updatedRow?.row, rowKey),
                  _.omit(r?.data, rowKey)
                );
            }
            
            if (isMatch) {
              matchedCount++;
              const newRowData = buildUpdatedRow(r.data);
              
              // Set the data first - this updates the row node's data
              r.setData(newRowData);
              
              // CRITICAL: Use refreshCells with the specific column to update only that cell
              // This prevents ag-Grid from re-reading the entire row from the server
              // We need to get the column object first
              const column = gridRef?.current?.api.getColumn(rowKey);
              if (column) {
                gridRef?.current?.api.refreshCells({
                  rowNodes: [r],
                  columns: [column],
                  force: true,
                });
              } else {
                // Fallback: refresh the entire row if column not found
                gridRef?.current?.api.refreshCells({
                  rowNodes: [r],
                  force: true,
                });
              }
            }
          });
          
          return;
        }

        if (Number(data.tableId) === Number(tableId)) {
          gridRef?.current?.api?.forEachNode((node) => {
            if (node.data && String(node.data[findKey]) === String(findValue)) {
              const newData = {
                ...node.data,
                ...updatedRowPayload.updateRow,
              };
              node.updateData(newData);
              gridRef?.current?.api.refreshCells({
                rowNodes: [node],
                force: true,
              });
            }
          });
        }
 else if (Number(data.tableId) === Number(childTableId)) {
    gridRef?.current?.api.forEachNode((masterNode) => {
       if (masterNode.data && masterNode.data[selectRowKey] === updatedRowPayload?.row?.[selectRowKey]) {
           const detailApi = masterNode.detailGridInfo?.api;

        if (detailApi) {
          detailApi.forEachNode((detailNode) => {
            if (detailNode.data && String(detailNode.data[findKey]) === String(findValue)) {
               const newDetailData = {
                ...detailNode.data,
                ...updatedRowPayload.updateRow,
                [rowKey]: updatedRowPayload.updatedValue
              };
     detailNode.updateData(newDetailData);
               detailApi.refreshCells({
                rowNodes: [detailNode],
                force: true, // Forces visual repaint
              });
            }
          });
        }
      }
    });
        }

      });

      // --- 5. UPDATE_ROWS: Bulk Row updates ---
      Events.subscribe(GRID_EVENTS.UPDATE_ROWS, (data) => {
        if (Number(data.tableId) === Number(tableId)) {
          const rowIdentifier = getGridMetadata(
            getState(),
            tableId
          )?.selectRowKey;
          gridRef?.current?.api?.forEachNode((node) => {
            if (
              node.data &&
              String(node.data[rowIdentifier]) ===
                String(data.updatedRow.row?.[rowIdentifier])
            ) {
              const newData = {
                ...node.data,
                ...data.updatedRow.row,
              };

              node.updateData(newData);
              gridRef?.current?.api?.refreshCells({
                rowNodes: [node],
                force: true,
              });
            }
          });
        }
      });

      // --- 6. DELETE_ROWS: Remove rows without flickering ---
      Events.subscribe(GRID_EVENTS.DELETE_ROWS, (data) => {
        const isMainTable = Number(data.tableId) === Number(tableId);
        const isChildTable = Number(data.tableId) === Number(childTableId);

        if (isMainTable || isChildTable) {
          const targetApi = isMainTable
            ? gridRef.current.api
            : childGridRef?.current?.api;
          if (targetApi) {
            targetApi.deselectAll();
            targetApi.refreshServerSide({ purge: false });
          }
        }
      });
    }
  }, [gridRef, tableId, childTableId, childGridRef, selectRowKey]);

  const onGridReady = useCallback(
    async (params) => {
      setLoading(true);
      if (!gridRef) {
        return;
      }
      const server = createServer(tableId);
      const datasource = createServerSideDatasource(server, gridRef, {
        isStorageEnabled,
        isViewImplementationOverride: isViewImplementationOverride || isViewRLA,
        tableId,
      });
      if (onDomRef) {
        onDomRef(gridRef);
      }
      params.api!.setGridOption("serverSideDatasource", datasource);
      setLoading(false);
    },
    [
      gridRef,
      isStorageEnabled,
      isViewImplementationOverride,
      isViewRLA,
      onDomRef,
      tableId,
    ]
  );

  const onChildGridReady = useCallback(
    (params) => {
      // Create server instance for child grid
      const fieldGroups = gridMeta?.ChildTableFieldGroups.reduce(
        (result, key) => {
          result[key] = params.context.parentRowData.data[key];
          return result;
        },
        {}
      );
      const server = createServer(childTableId);

      // Create server-side datasource with required config
      const datasource = createServerSideDatasource(server, childGridRef, {
        isStorageEnabled,
        isViewImplementationOverride: isViewImplementationOverride || isViewRLA,
        tableId: childTableId,
        body: { fieldGroups },
      });
      // Set the datasource on the child grid
      params.api!.setGridOption("serverSideDatasource", datasource);
    },
    [
      childGridRef,
      childTableId,
      gridMeta?.ChildTableFieldGroups,
      isStorageEnabled,
      isViewImplementationOverride,
      isViewRLA,
    ]
  );

  const onColumnPivotModeChanged = useCallback(
    (params) => {
      const { api } = params;
      if (!api.isPivotMode()) {
        // Clear any existing timeout to avoid duplicate refresh
        if (timeoutIdRef.current !== null) {
          clearTimeout(timeoutIdRef.current);
        }

        // Schedule grid refresh after a short delay
        timeoutIdRef.current = setTimeout(() => {
          dispatch(refreshGridData({ tableId }));
        }, 2000);
      }
    },
    [dispatch, tableId]
  );

  const bulkBuffer = useRef({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const hasUnsavedChangesRef = useRef(false);
  const pendingApiCallRef = useRef(false); // Track if API call is in progress
  const lastEditMetaDataRef = useRef(null); // Store metadata for the last edit to use in API call
  const originalValuesRef = useRef({}); // Store original values for error reversion

  const publishDirtyState = useCallback(() => {
    const isDirty = hasUnsavedChanges || pendingApiCallRef.current || Object.keys(bulkBuffer.current).length > 0;
    Events.publish(GRID_EVENTS.DIRTY_STATE_CHANGED, { tableId, isDirty });
  }, [hasUnsavedChanges, tableId]);

    // Keep ref in sync with state
  useEffect(() => {
    publishDirtyState();
  }, [publishDirtyState]);

  // Debounced function that sends bulk update after user stops editing
  const debouncedSendBulk = useRef(
    debounce(() => {
      // Only send API call if there are pending edits in the buffer
      if (Object.keys(bulkBuffer.current).length === 0) {
        return;
      }

      // Get the latest metadata from the last edit
      const lastEditMeta = lastEditMetaDataRef.current;
      if (!lastEditMeta) {
        return;
      }

      const { tableId: editTableId, metaData: editMetaData, row: lastRow, rowIdentifier: lastRowIdentifier, isInlineEdit: lastIsInlineEdit, pageNumber: lastPageNumber } = lastEditMeta;

      // Get fresh metadata to avoid stale data after idle time
      const freshMetaData = getGridMetadata(getState(), editTableId) || editMetaData;

      // Get the updated value from the buffer for the last edited row
      const qtyKey = editTableId === 1 ? "OrderQty" : "ItemOrderQty";
      const selectRowKey = freshMetaData?.selectRowKey || editMetaData?.selectRowKey;
      const lastRowId = editTableId === 1 || editTableId === 2 || editTableId !== 3
        ? lastRow[selectRowKey]
        : lastRow.OrderDetailVarietyID;
      const lastEditInBuffer = bulkBuffer.current[lastRowId];
      const updatedValue = lastEditInBuffer ? lastEditInBuffer[qtyKey] : lastRow[lastRowIdentifier];

      // Create final payload with all accumulated edits - use fresh metadata
      const finalPayload = {
        tableId: editTableId,
        row: lastRow,
        rowIdentifier: lastRowIdentifier,
        updatedValue: updatedValue,
        isInlineEdit: lastIsInlineEdit,
        metaData: freshMetaData, // Use fresh metadata instead of potentially stale editMetaData
        pageNumber: lastPageNumber,
        BulkUpdateJSON: Object.values(bulkBuffer.current),
      };

      // Clear buffer before API call to prevent duplicate sends
      const bufferCopy = { ...bulkBuffer.current };
      bulkBuffer.current = {};

      // Mark API call as pending for order tables
      if (editTableId === 1 || editTableId === 2 || editTableId === 3) {
        pendingApiCallRef.current = true;
        publishDirtyState();
      }

      dispatch(updateRowData(finalPayload));
    }, 1000) // Increased to 1000ms (1 second) to allow more time for bulk edits
  ).current;

  // Cleanup refs when component unmounts or tableId changes (navigation)
  useEffect(() => {
    return () => {
      // Cleanup on unmount or tableId change
      // Cancel any pending debounced calls
      if (debouncedSendBulk && typeof debouncedSendBulk.cancel === 'function') {
        debouncedSendBulk.cancel();
      }
      // Clear refs to prevent stale data after navigation
      bulkBuffer.current = {};
      lastEditMetaDataRef.current = null;
      originalValuesRef.current = {};
      pendingApiCallRef.current = false;
    };
  }, [tableId, debouncedSendBulk]);

  // const publishDirtyState = useCallback(() => {
  //   const isDirty = hasUnsavedChanges || pendingApiCallRef.current || Object.keys(bulkBuffer.current).length > 0;
  //   Events.publish(GRID_EVENTS.DIRTY_STATE_CHANGED, { tableId, isDirty });
  // }, [hasUnsavedChanges, tableId]);

    // Keep ref in sync with state
  useEffect(() => {
    publishDirtyState();
  }, [publishDirtyState]);

  // Debounced function that sends bulk update after user stops editing
  // const debouncedSendBulk = useRef(
  //   debounce(() => {
  //     // Only send API call if there are pending edits in the buffer
  //     if (Object.keys(bulkBuffer.current).length === 0) {
  //       return;
  //     }

  //     // Get the latest metadata from the last edit
  //     const lastEditMeta = lastEditMetaDataRef.current;
  //     if (!lastEditMeta) {
  //       return;
  //     }

  //     const { tableId: editTableId, metaData: editMetaData, row: lastRow, rowIdentifier: lastRowIdentifier, isInlineEdit: lastIsInlineEdit, pageNumber: lastPageNumber } = lastEditMeta;

  //     // Get fresh metadata to avoid stale data after idle time
  //     const freshMetaData = getGridMetadata(getState(), editTableId) || editMetaData;

  //     // Get the updated value from the buffer for the last edited row
  //     const qtyKey = editTableId === 1 ? "OrderQty" : "ItemOrderQty";
  //     const selectRowKey = freshMetaData?.selectRowKey || editMetaData?.selectRowKey;
  //     const lastRowId = editTableId === 1 || editTableId === 2 || editTableId !== 3
  //       ? lastRow[selectRowKey]
  //       : lastRow.OrderDetailVarietyID;
  //     const lastEditInBuffer = bulkBuffer.current[lastRowId];
  //     const updatedValue = lastEditInBuffer ? lastEditInBuffer[qtyKey] : lastRow[lastRowIdentifier];

  //     // Create final payload with all accumulated edits - use fresh metadata
  //     const finalPayload = {
  //       tableId: editTableId,
  //       row: lastRow,
  //       rowIdentifier: lastRowIdentifier,
  //       updatedValue: updatedValue,
  //       isInlineEdit: lastIsInlineEdit,
  //       metaData: freshMetaData, // Use fresh metadata instead of potentially stale editMetaData
  //       pageNumber: lastPageNumber,
  //       BulkUpdateJSON: Object.values(bulkBuffer.current),
  //     };

  //     // Clear buffer before API call to prevent duplicate sends
  //     const bufferCopy = { ...bulkBuffer.current };
  //     bulkBuffer.current = {};

  //     // Mark API call as pending for order tables
  //     if (editTableId === 1 || editTableId === 2 || editTableId === 3) {
  //       pendingApiCallRef.current = true;
  //       publishDirtyState();
  //     }

  //     dispatch(updateRowData(finalPayload));
  //   }, 1000) // Increased to 1000ms (1 second) to allow more time for bulk edits
  // ).current;

  const onUpdateCell = (e) => {
    const row = e.data;
    const rowIdentifier = e.colDef.field;
    const parsedValue = e.data[rowIdentifier];
    const type = e.colDef.metaData.ColumnType;
    const tableId = Number(e.colDef.metaData.tableId);
    const isInlineEdit = !(tableId === 56 || tableId === 37);
    const pageNumber = Math.floor(e?.node?.rowIndex / 50) + 1;

    // Parse value based on type
    const updatedValue =
      type === "qty"
        ? parsedValue || parsedValue === 0
          ? parsedValue
          : "0"
        : type === "number"
        ? Number(parsedValue)
        : parsedValue;

     const standardKey = row[metaData.selectRowKey];
    const rowId =
      tableId === 1 || tableId === 2 || tableId !== 3
        ? standardKey
        : row.OrderDetailVarietyID;

    if (tableId === 2 || tableId === 1 || tableId === 3) {
      const qtyKey = tableId === 1 ? "OrderQty" : "ItemOrderQty";
      
      // Store original value for error reversion if not already stored
      if (!originalValuesRef.current[rowId]) {
        const currentValue = row[rowIdentifier];
        originalValuesRef.current[rowId] = {
          [rowIdentifier]: typeof currentValue === 'object' && currentValue?.value !== undefined 
            ? currentValue.value 
            : currentValue
        };
      }
      
      // Update the buffer with the latest edit - merge with existing buffer entry to support multiple columns
      const existingBufferEntry = bulkBuffer.current[rowId] || { RowIdentifier: rowId };
      bulkBuffer.current[rowId] = {
        ...existingBufferEntry,
        [qtyKey]: updatedValue,
        // Also store the rowIdentifier being edited for tracking
        _lastEditedColumn: rowIdentifier,
      };
      
      // Store metadata from this edit to use in the final API call
      lastEditMetaDataRef.current = {
        tableId,
        row,
        rowIdentifier,
        metaData,
        isInlineEdit,
        pageNumber,
      };
      
      publishDirtyState();

      // Trigger debounced API call - this will be cancelled and restarted on each edit
      // Only the last call (after user stops editing) will execute
      debouncedSendBulk();
      return;
    }

    const TRIGGER_TABLE_IDS = new Set([1, 2, 3, 115]);

    if (TRIGGER_TABLE_IDS.has(tableId)) {
      pendingApiCallRef.current = true;
      publishDirtyState();
    }
    dispatch(
      updateRowData({
        tableId,
        row,
        rowIdentifier,
        updatedValue,
        isInlineEdit,
        metaData,
        pageNumber,
      })
    );
  };

  const onCellEditRequest = (params) => {
    const { api, colDef, data, value } = params;
    const cellRanges = api.getCellRanges();
    const { columns, endRow, startRow } = extractRangeInfo(
      cellRanges,
      "columns"
    );
    const getRowsInRange = (startIndex, endIndex) => {
      const rows = [];

      for (let i = startIndex; i <= endIndex; i++) {
        const rowNode = gridRef.current.api.getDisplayedRowAtIndex(i);
        if (rowNode) {
          rows.push({
            rowIndex: i,
            data: rowNode.data,
            rowNode, // if you want full metadata
          });
        }
      }

      return rows;
    };

    // Example usage:
    const displayRows = getRowsInRange(startRow, endRow);
    const rows = _.map(displayRows, (r) => r.data);
    const rowIdentifiers = columns
      .filter((c) => !c.colDef.suppressFillHandle)
      .map((c) => c.colDef.field);
    const selectRowKeyValues = _.map(rows, (r) => r[selectRowKey]);
    const row = data;
    const rowIdentifier = colDef.field;
    const parsedValue = value;
    const type = colDef.metaData.ColumnType;

    // Handle value based on column type
    const updatedValue =
      type === "qty"
        ? parsedValue || parsedValue === 0
          ? parsedValue
          : "0"
        : type === "number"
        ? Number(parsedValue)
        : parsedValue;

    // Dispatch updated row dat
  };

  // const onSelectionChanged = (params) => {
  //   const { api, source, serverSideState } = params;

  //   // Step 1: Read selection state from server-side selection
  //   const selectionState = serverSideState?.selectionState
  //   const toggledNodes = serverSideState?.toggledNodes ?? [];

  //   console.log(toggledNodes)

  //   // Step 2: Extract selected node IDs (group or row keys)
  //   const rowKeys = toggledNodes
  //     .map((node) => node.nodeId)
  //     .filter((item) => !item.includes("group"));

  //   // Optional: If you use custom row/group key names
  //   const rowGroups = toggledNodes
  //     .filter((node) => node.nodeId?.includes("group"))
  //     .map((node) => ({
  //       nodeId: node.nodeId,
  //       selectAllChildren: node.selectAllChildren,
  //     }));

  //   switch (source) {
  //     case "checkboxSelected": {
  //       dispatch(
  //         updateSelectedRows({
  //           tableId,
  //           selectedRowKeys: rowKeys,
  //           rowGroup: rowGroups,
  //           isSelectAll: false,
  //         })
  //       );
  //       break;
  //     }

  //     case "uiSelectAll": {
  //       selectionState?.selectAllChildren ? api.selectAll() : api.deselectAll();
  //       break;
  //     }

  //     case "api": {
  //       const addRowKeys = _.union(rowKeys, selectedInfo.selectedRowKeys);
  //       const missingRowKeys = _.xor(rowKeys, selectedInfo.selectedRowKeys);

  //       const addRowGroups = _.unionWith(
  //         rowGroups,
  //         selectedInfo.groups,
  //         _.isEqual
  //       );
  //       const missingRowGroups = _.xorWith(
  //         rowGroups,
  //         selectedInfo.groups,
  //         _.isEqual
  //       );

  //       const shouldUpdate =
  //         missingRowKeys.length > 0 || missingRowGroups.length > 0;

  //       if (shouldUpdate) {
  //         dispatch(
  //           updateSelectedRows({
  //             tableId,
  //             selectedRowKeys: addRowKeys,
  //             rowGroup: addRowGroups,
  //             isSelectAll: selectedInfo.isSelectAll,
  //           })
  //         );
  //       }

  //       break;
  //     }

  //     case "apiSelectAll": {
  //       dispatch(
  //         updateSelectedRows({
  //           tableId,
  //           selectedRowKeys: rowKeys,
  //           isSelectAll: selectionState?.selectAllChildren,
  //           rowGroup: rowGroups,
  //         })
  //       );
  //       break;
  //     }

  //     default:
  //       break;
  //   }
  // };

  
  const onSelectionChanged = (params) => {
    // Note: The AG Grid prop should be: onSelectionChanged={_.debounce(onSelectionChanged, 100)}

    const { api, source, serverSideState } = params;
    const { selectAllChildren } = serverSideState;

    // 1. Get current selection state from the grid and previous state from Redux
    const nodes = api.getSelectedNodes();
    const rowKeys = _.compact(nodes?.map((n) => n?.data?.[selectRowKey]));
    const previouslySelectedKeys = selectedInfo?.selectedRowKeys || [];
    const previouslySelectedGroups = selectedInfo?.rowGroup || [];

    // 2. Extract parent/group info from currently selected nodes
    // Filter out child nodes whose parent is also selected (to find top-level group selections)
    const parentIds = _.filter(
      _.map(nodes, (n) => n.parent),
      (n) => n?.id
    ).map((n) => n.id);

    const rowGroups = _.filter(nodes, (n) => n.group).filter(
      (n) => !parentIds.includes(n?.id)
    );

    // --- ROW SELECTION MERGING LOGIC ---

    // A. Start with a union of all known selected keys
    let mergedRowKeys = _.union(previouslySelectedKeys, rowKeys);

    // B. Find keys that were selected but are no longer in the visible set (i.e., deselected)
    const deselectedKeys = _.difference(previouslySelectedKeys, rowKeys);

    // C. Remove deselected keys from the merged list (This handles single-row deselection)
    mergedRowKeys = _.difference(mergedRowKeys, deselectedKeys);

    // --- GROUP SELECTION MERGING LOGIC (THE FIX) ---

    let mergedRowGroups;

    // The logic must handle the "Clear All" case where the grid reports []
    if (rowKeys.length === 0 && rowGroups.length === 0) {
      // If the grid reports no selections, we treat this as a full clear
      // IF there were previously selected items.
      if (
        previouslySelectedKeys.length > 0 ||
        previouslySelectedGroups.length > 0
      ) {
        mergedRowGroups = []; // Explicitly clear groups
      } else {
        mergedRowGroups = previouslySelectedGroups; // Stay empty
      }
    } else {
      // Standard additive merge logic for groups
      mergedRowGroups = _.unionWith(
        previouslySelectedGroups,
        rowGroups,
        _.isEqual
      );
    }

    // 4. Dispatch the new selection state based on the source
    switch (source) {
      case "checkboxSelected": {
        // A single checkbox change (add or remove)
        dispatch(
          updateSelectedRows({
            tableId,
            selectedRowKeys: mergedRowKeys,
            rowGroup: mergedRowGroups,
            isSelectAll: false, // Individual selection cannot set global select all
          })
        );
        break;
      }

      case "uiSelectAll": {
        // The header checkbox was clicked to select/deselect all loaded nodes
        dispatch(
          updateSelectedRows({
            tableId,
            selectedRowKeys: mergedRowKeys,
            rowGroup: mergedRowGroups,
            // If the header box is checked, set isSelectAll based on serverSideState
            isSelectAll: selectAllChildren,
          })
        );
        break;
      }

      case "apiSelectAll": {
        // Selection was done via api.selectAll() (e.g., from your 'Select All records' link)
        dispatch(
          updateSelectedRows({
            tableId,
            selectedRowKeys: mergedRowKeys,
            rowGroup: mergedRowGroups,
            isSelectAll: selectAllChildren,
          })
        );
        break;
      }

      case "api":
      default: {
        // 'api' source usually happens when the grid loads data or refreshes nodes.
        // We dispatch the new state to ensure selection is preserved, but do not
        // override the global selectAll flag unless it's an explicit full selection event.
        if (mergedRowKeys.length > 0 || mergedRowGroups.length > 0) {
          dispatch(
            updateSelectedRows({
              tableId,
              selectedRowKeys: mergedRowKeys,
              rowGroup: mergedRowGroups,
              isSelectAll: selectedInfo?.isSelectAll || false,
            })
          );
        }
        break;
      }
    }
  };

  const onSelectAllClick = () => gridRef.current.api.selectAll();

  const onClearSelectAll = () => {
    dispatch(
      updateSelectedRows({
        tableId,
        selectedRowKeys: [],
        rowGroup: [],
        isSelectAll: false,
      })
    );

    gridRef.current.api.deselectAll();
  };

  const onModelUpdated = useCallback(
    (params) => {
      const { api } = params;
      handleUpdateGrouping(_.some(api.getColumnDefs(), (f) => f.rowGroup));
      if (api.getRenderedNodes().length) {
        api.hideOverlay();
      }
      const selectedChildren = api.getSelectedNodes();
      if (selectedChildren.length) {
        const rowKeys = _.compact(
          selectedChildren
            .filter((node) => !node.group)
            .map((n) => n?.data?.[selectRowKey])
        );
        const parentIds = _.filter(
          _.map(selectedChildren, (n) => n.parent),
          (n) => n?.id
        ).map((n) => n.id);
        const rowGroups = _.filter(selectedChildren, (n) => n.group).filter(
          (n) => !parentIds.includes(n?.id)
        );
        dispatch(
          updateSelectedRows({
            tableId,
            selectedRowKeys: rowKeys,
            rowGroup: rowGroups,
            isSelectAll: selectedInfo?.isSelectAll ?? false,
          })
        );
      }
    },
    [dispatch, selectRowKey, selectedInfo?.isSelectAll, tableId]
  );

  const onColumnMenuVisibleChanged = useCallback((event) => {
    const { column, api, visible } = event;
    if (!visible || !column) return;

    // Timeout ensures menu DOM is mounted before attempting filter access
    setTimeout(() => {
      api.getColumnFilterInstance(column);
    }, 0);
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    const { api } = params;
    const allColumns = api.getAllDisplayedColumns();

    let index = 0;

    const processNext = () => {
      if (index >= allColumns.length) return;
      const column = allColumns[index];
      if (column) {
        // same logic as onColumnMenuVisibleChanged but without event
        setTimeout(() => {
          api.getColumnFilterInstance(column);
          index++;
          processNext(); // call the next column after the current one
        }, 50); // delay between each column (tweak as needed)
      }
    };

    processNext();
  }, []);

  const hasAnyChildExpanded = useRef(false);

  const onRowGroupOpened = useCallback(
    (params) => {
      // Handle row group expansion (aggregated groups)
      if (params.node.group) {
        // When expanding a row group, ag-Grid's server-side row model
        // automatically fetches child data. We should NOT trigger a full refresh
        // as it would clear aggregated rows. The server-side datasource handles
        // group expansion automatically via getRows() with groupKeys.
        return;
      }

      // Handle master/detail expansion (child table rows)
      if (!gridMeta?.ChildTableID) {
        return;
      }

      // only run for the first expanded child row in the grid
      if (!hasAnyChildExpanded.current && params.node.expanded) {
        hasAnyChildExpanded.current = true;

        dispatch(
          updateMetadata({
            tableId: gridMeta?.ChildTableID,
            metaData: {
              selectRowKey: gridMeta?.childTableSelectRowKey,
              dataProviderOptions: {
                ...REQUESTS.POST.GET_GRID_DETAILS_V2,
                type: "POST",
                service: gridMeta?.dataProviderOptions?.service,
                isSubgrid: true,
                parentTable: tableId,
                version: 2,
                url: gridMeta?.dataProviderOptions?.url,
                pathParams: { tableId: gridMeta?.ChildTableID },
              },
            },
            isAppend: true,
          })
        );
      }
    },
    [
      dispatch,
      gridMeta?.ChildTableID,
      gridMeta?.childTableSelectRowKey,
      gridMeta?.dataProviderOptions?.service,
      gridMeta?.dataProviderOptions?.url,
      tableId,
    ]
  );

  const rowsToCollapseRef = useRef<Set<object>>(new Set());

  const getContextMenuItems = useCallback(
    (params) => {
      let result = [
        "copy",
        "copyWithHeaders",
        "copyWithGroupHeaders",
        "paste",
        ...(gridMeta?.UploadTableID
          ? [
              "separator",
              {
                name: "Export",
                action: () => {
                  Events.publish(GRID_EVENTS.EXPORT, {
                    tableId,
                    isAgGrid: true,
                  });
                },
              },
            ]
          : []),
        "separator",
        {
          name: "Expand All",
          action: () => {
            rowsToCollapseRef.current.clear();
            // Row Group expansion (if applicable)
            if (typeof params.api.expandAll === "function") {
              params.api.expandAll();
            }

            // Master/Detail expansion
            params.api.forEachNode((node) => {
              if (node.master) {
                node.setExpanded(true);
              }
            });
          },
        },
        {
          name: "Collapse All",
          action: () => {
            // Row Group collapse (if applicable)
            if (typeof params.api.collapseAll === "function") {
              params.api.collapseAll();
            }

            // Master/Detail collapse
            params.api.forEachNode((node) => {
              if (node.master && node.expanded) {
                rowsToCollapseRef.current.add(node);
              }
            });
            setTimeout(() => {
              const visibleNodes = params.api.getRenderedNodes();
              visibleNodes.forEach((node) => {
                if (node.master && node.expanded) {
                  // collapse visible ones immediately
                  node.setExpanded(false);
                  rowsToCollapseRef.current.delete(node);
                }
              });
            }, 0);
          },
        },
      ];
      return result;
    },
    [tableId, gridMeta]
  );

  const onViewportChanged = _.throttle((params) => {
    if (!rowsToCollapseRef.current?.size) return;

    setTimeout(() => {
      const visibleNodes = params.api.getRenderedNodes();
      visibleNodes.forEach((node) => {
        if (node.expanded && rowsToCollapseRef.current.has(node)) {
          node.setExpanded(false);
          rowsToCollapseRef.current.delete(node);
        }
      });
    }, 0);
  });

  return {
    onColumnMoved,
    onColumnPinned,
    onColumnVisible,
    onProcessColumnQueue,
    onColumnResized,
    onUpdateCell,
    onSelectionChanged,
    onSelectAllClick,
    onClearSelectAll,
    onColumnPivotModeChanged,
    onModelUpdated,
    onRowGroupOpened,
    refreshTimestamp,
    isGroupingEnabled,
    loading,
    onGridReady,
    onChildGridReady,
    selectedInfo,
    onColumnMenuVisibleChanged,
    onCellEditRequest,
    onFirstDataRendered,
    getContextMenuItems,
    onViewportChanged,
  };
}
